/**
 * 在地图上显示 School 信息，包括 boundary
 * 
 * @Author: Focci
 * @Date: 2023-08-01 13:52:40
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-01 13:52:40
 */

'use client'

import useFetch from '@hook/useFetch'
import { Boundary, fitBoundsDelay, useMapState } from '@comp/mapbox'
import { useMap, Marker } from 'react-map-gl'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { SchoolMarker } from './marker/SchoolMarkers'
import { SchoolCard } from './popup/PropertyCards'
import CustomPopup from './popup/CustomPopup'
import { CircleBoundary } from './Boundary'

export function SchoolInfoBody({
  data,
  showBoundary = true,
  onBoundaryChange,
}) {
  const { current: mapbox } = useMap()
  const { events } = useMapState()
  const [popupData, setPopupData] = useState(data)

  const handleClose = useCallback(() => setPopupData(null), [])
  const handleClick = useCallback(() => setPopupData(data), [data])

  const schoolMarkerProps = useMemo(() => {
    const { school_type_id: schoolTypeId, authority_source: authority } = data
    return { item: { schoolTypeId, authority } }
  }, [data])

  const switchProps = useMemo(() => ({
    checked: showBoundary,
    color: '#ff8500',
    onChange: onBoundaryChange,
  }), [showBoundary, onBoundaryChange])

  useEffect(() => {
    showBoundary && fitBoundsDelay(mapbox, data?.coordinates)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, mapbox])

  if(!(data?.lng && data?.lat)) {
    return null
  }

  return (
    <>
      <Marker 
        latitude={data.lat} 
        longitude={data.lng}
        style={{ zIndex: 5 }}
        onClick={handleClick}
      >
        <SchoolMarker {...schoolMarkerProps} />
      </Marker>
      
      {showBoundary && (
        data?.has_school_network > 0 
          ? (
            <Boundary
              data={data?.coordinates}
              borderColor="#ff8500"
              needFill
              color="#ff8500"
            />
          )
          : <CircleBoundary center={[data.lng, data.lat]} />
      )}
      {popupData && (
        <CustomPopup 
          onClose={handleClose}
          data={popupData}
        >
          <SchoolCard data={data} switchProps={switchProps} events={events} />
        </CustomPopup>
      )}
    </>
  )
}

export function SchoolInfoStatus(props) {
  const [showBoundary, setShowBoundary] = useState(true)

  return (
    <SchoolInfoBody 
      {...props}
      showBoundary={showBoundary}
      onBoundaryChange={(e) => setShowBoundary(e.target.checked)}
    />
  )
}

export default function SchoolInfo({
  schoolId = null,
  ...props
}) {
  const { data } = useFetch(`school/${schoolId}`)
  
  return (
    <SchoolInfoBody {...props} data={data} />
  )
}
